export function validateRequirements(job_requirment) {
  if (!job_requirment) return "select qulifications";
  return "";
}
